import { DateTime } from "luxon";
import { isNaN } from "lodash";
import { StringUtils } from "../strings";

const numberOrZero = (value) => (!isNaN(value) ? value : 0);

/**
 * This is a parser for passTrasactions
 * It mainly serves the managePass modal
 * @param {*} passTransactions
 * @param {*} activePass
 */
const parser = (currentTransaction, activePass) => {
  const maxRides = activePass?.pass_offer?.pass_offer_type?.max_rides;

  const remainingPassCountDown = StringUtils.countDown(activePass?.expiration_date);
  const tokens = remainingPassCountDown.split(" ");
  const remainingPassDuration = tokens.slice(0, Math.min(2, tokens.length)).join(" ");

  const previouslyCashedOut = currentTransaction?.amount - currentTransaction?.cash_out_remaining;
  const remainingTripValue =
    (activePass?.pass_offer.price / maxRides) * activePass?.rides_remaining;

  const totalHours = activePass?.expiration_date
    ? DateTime.fromISO(activePass?.expiration_date).diffNow().as("hours")
    : 0;

  const remainingPassValue =
    (totalHours * currentTransaction?.amount) /
    (currentTransaction?.pass_offer.pass_offer_type.length * 24);

  const totalDays = activePass?.expiration_date
    ? DateTime.fromISO(activePass?.expiration_date).diffNow().as("days")
    : 0;

  const valuePerDay = remainingPassValue / totalDays;
  const valuePerHour = remainingPassValue / totalHours;
  const valuePerTrip = remainingTripValue / activePass.rides_remaining;
  const availableForCashout = currentTransaction?.cash_out_remaining;

  return {
    remainingTripValue: numberOrZero(remainingTripValue),
    remainingPassValue,
    remainingPassCountDown,
    remainingPassDuration,
    previouslyCashedOut: numberOrZero(previouslyCashedOut),
    valuePerDay: numberOrZero(valuePerDay),
    valuePerHour: numberOrZero(valuePerHour),
    valuePerTrip: numberOrZero(valuePerTrip),
    availableForCashout,
    currentTransactionId: currentTransaction?.id,
    currency: currentTransaction?.currency,
    status: currentTransaction?.status,
  };
};

export default parser;
